import { useDimensions } from '@react-native-community/hooks'
import { getDeviceTypeAsync, DeviceType } from 'expo-device'
import { useState, useEffect } from 'react'
import { Platform } from 'react-native'

import { ANDROID, IOS, theme, WEB } from '~constants'

type ReturnType = {
  deviceSpecificWidth: number
  isAndroid: boolean
  isIOS: boolean
  isWeb: boolean
  isTablet: boolean
  isPhone: boolean
  shouldApplyDesktopStyles: boolean
  shouldApplyWideScreenStyles: boolean
}
const {
  breakpoints: { desktop, tablet },
} = theme
const { PHONE, DESKTOP, TABLET } = DeviceType

const deviceTypeInitialState = {
  [PHONE]: false,
  [DESKTOP]: false,
  [TABLET]: false,
}
export const useDeviceInfo: () => ReturnType = () => {
  const [deviceType, setDeviceType] =
    useState<typeof deviceTypeInitialState>(deviceTypeInitialState)
  // width of available screen space regarding breakpoints and type of Device
  const [width, setWidth] = useState<number>(0)

  const {
    screen: { width: screenWidth },
    window: { width: windowWidth },
  } = useDimensions()

  useEffect(() => {
    getDeviceTypeAsync().then((deviceType) => {
      setDeviceType((prevState) => ({ ...prevState, [deviceType]: true }))
    })
  }, [setDeviceType])

  useEffect(() => {
    switch (true) {
      case !deviceType[DESKTOP]:
        setWidth(screenWidth)
        break
      case windowWidth < tablet:
        setWidth(windowWidth)
        break
      case windowWidth >= tablet && windowWidth < desktop:
        setWidth(tablet)
        break
      case windowWidth >= desktop:
        setWidth(desktop)
        break
      default:
        setWidth(screenWidth)
    }
  }, [deviceType, screenWidth, windowWidth])

  return {
    deviceSpecificWidth: width,
    isAndroid: Platform.OS === ANDROID,
    isIOS: Platform.OS === IOS,
    isPhone: deviceType[PHONE],
    isTablet: deviceType[TABLET],
    isWeb: Platform.OS === WEB,
    shouldApplyDesktopStyles: width >= desktop,
    shouldApplyWideScreenStyles: width >= tablet,
  }
}
